export default __webpack_public_path__ + "static/media/JoinRider.962e4720.png";